import { Address } from '@adyen/adyen-web';
import Hours from './Hours';

export class Company {
	_id?: string;
	venue: string;
	name: string;
	companyCode: string;
	openingHours: Hours[];
	invoiceAddress: Address;
	deliveryAddress: {
		city: string;
		location: any;
		number: string;
		postalCode: string;
		street: string;
	};
	vatNumber: string;
	phoneNumber: string;
	email: string;
	subsidy: string;
	isPaidByCompany: boolean;
	storeDiscount: string;
	subsidyOrderMinimum: string;
	// deliveryTimes: DeliveryTim[];
}
